module.exports = __webpack_public_path__ + "img/Felipe_Kettle.8a7950e0.jpg";